"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartTextClickEnum = void 0;
var EventLabelCartTextClickEnum;
(function (EventLabelCartTextClickEnum) {
    EventLabelCartTextClickEnum["AddTicket"] = "Add Ticket";
    EventLabelCartTextClickEnum["Services"] = "Services";
    EventLabelCartTextClickEnum["TermsAndConditions"] = "Terms and conditions";
    EventLabelCartTextClickEnum["RightOfWithDrawl"] = "Right of withdrawal";
    EventLabelCartTextClickEnum["PrivacyPolicy"] = "Privacy policy";
    EventLabelCartTextClickEnum["AddValueVoucher"] = "Add Value Voucher";
    EventLabelCartTextClickEnum["DeleteValueVoucher"] = "Delete Value Voucher";
    EventLabelCartTextClickEnum["Discharge"] = "Discharge";
    EventLabelCartTextClickEnum["Discount"] = "Redeem discount";
    EventLabelCartTextClickEnum["PackageTour"] = "Formblatt-Pauschalreise";
    EventLabelCartTextClickEnum["PartnerTermsAndConditions"] = "AGB_Partner";
    EventLabelCartTextClickEnum["Intermediary"] = "Intermediary";
    EventLabelCartTextClickEnum["WishlistNotification"] = "Link to wishlist in notification";
    EventLabelCartTextClickEnum["BackToProviderList"] = "Back To Provider List";
    EventLabelCartTextClickEnum["Unsubscribe"] = "Unsubscribe";
})(EventLabelCartTextClickEnum || (exports.EventLabelCartTextClickEnum = EventLabelCartTextClickEnum = {}));
//# sourceMappingURL=EventLabelCartTextClickEnum.js.map